export class Filtering {
  static VisibleWorkstations: string[] = [];
}